import type { PartialDeep } from 'type-fest';
import { CaptchaConfig, UserFlow } from '../networkConfig';
import { Configuration } from '../defaultConfig';

const chainConfig: PartialDeep<Configuration> = {
  flowConfigs: {
    [UserFlow.CAPTCHA]: {
      issuance: {
        providers: {
          // authenticationDisabled is a flag to legacy React Components to not run the POWO step
          captcha: {
            authenticationDisabled: true,
          } as CaptchaConfig,
        },
      },
    },
  },
};

export default chainConfig;
